import { render, staticRenderFns } from "./navModule.vue?vue&type=template&id=122fb24c"
import script from "./navModule.vue?vue&type=script&lang=js"
export * from "./navModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports